import { css, SerializedStyles } from '@emotion/react';
import { FC, HTMLAttributes } from 'react';
import { useBorderColor } from '@/providers/borderColor';

interface Props {
  customStyle?: SerializedStyles;
}

export const Index: FC<Props & HTMLAttributes<HTMLDivElement>> = ({ customStyle, ...rest }) => {
  // Brand-aware divider colour, derived from the merchant seeds (PAA-2548).
  const borderColor = useBorderColor();

  return (
    <div
      css={[
        customStyle,
        css`
          ${customStyle};
          border: none;
          height: 1px;
          background: ${borderColor};
        `,
      ]}
      {...rest}
    />
  );
};

export default Index;
